module.exports = __webpack_public_path__ + "img/poster2.be869647.png";